import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useSearchParams, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CategoriesProvider } from "./context/CategoriesContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Header } from "./components/Header";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Toaster } from "./components/ui/sonner";
import PdfLibrary from "./pages/PdfLibrary";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminCategories from "./pages/AdminCategories";
import AdminImport from "./pages/AdminImport";

function Layout({ children }) {
  const [params] = useSearchParams();
  const location = useLocation();
  const embedMode = params.get("embed") === "1" && location.pathname === "/";
  return (
    <div className="App min-h-screen bg-slate-50">
      {!embedMode && <Header />}
      <main>{children}</main>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CategoriesProvider>
          <BrowserRouter>
            <Layout>
              <ErrorBoundary>
                <Routes>
                  <Route path="/" element={<PdfLibrary />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/admin/categories" element={<AdminCategories />} />
                  <Route path="/admin/import" element={<AdminImport />} />
                </Routes>
              </ErrorBoundary>
            </Layout>
            <Toaster position="top-right" richColors visibleToasts={2} duration={2800} />
          </BrowserRouter>
        </CategoriesProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
